/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {useAnyPermission, usePermission, usePublic} from "../../../Hooks/PermissionHooks";

export const PermissionCheckerEnhance = (ComposedComponent) => function PermissionCheckerEnhance(props) {
    const isPublic = usePublic();
    const permission = usePermission();
    const anyPermission = useAnyPermission();

    return <ComposedComponent
        {...props}
        HasPermission={permission}
        HasAnyPermission={anyPermission}
        IsPublic={isPublic}
    />;
};
